export enum UpdateContactInfoError {
  // Auth0 errors
  EmailAlreadyExists = "EMAIL_ALREADY_EXISTS",
  PhoneAlreadyExists = "PHONE_ALREADY_EXISTS",
  AccountAlreadyExists = "ACCOUNT_ALREADY_EXISTS",
  InvalidEmailFormat = "INVALID_EMAIL_FORMAT",
  InvalidPhoneFormat = "INVALID_PHONE_FORMAT",
  InvalidInformationFormat = "INVALID_INFORMATION_FORMAT",
  Auth0AuthenticationFailed = "AUTH0_AUTHENTICATION_FAILED",
  Auth0AccessDenied = "AUTH0_ACCESS_DENIED",
  Auth0UserNotFound = "AUTH0_USER_NOT_FOUND",
  Auth0RateLimit = "AUTH0_RATE_LIMIT",
  Auth0ServiceUnavailable = "AUTH0_SERVICE_UNAVAILABLE",
  Auth0OperationFailed = "AUTH0_OPERATION_FAILED",

  // Authorization errors
  NonGuardianUser = "NON_GUARDIAN_USER",
  CannotUpdateUserProfile = "CANNOT_UPDATE_USER_PROFILE",

  // Validation errors
  EmailOrPhoneRequired = "EMAIL_OR_PHONE_REQUIRED",
  NoIdentityProvider = "NO_IDENTITY_PROVIDER",
  EmailRequired = "EMAIL_REQUIRED",
  PhoneRequired = "PHONE_REQUIRED",

  // Database errors
  DatabaseEmailUpdate = "DATABASE_EMAIL_UPDATE_FAILED",
  DatabasePhoneUpdate = "DATABASE_PHONE_UPDATE_FAILED",

  // System errors
  RequestParseFailed = "REQUEST_PARSE_FAILED",
  ClaimsCreationFailed = "CLAIMS_CREATION_FAILED",
  PermissionsRetrievalFailed = "PERMISSIONS_RETRIEVAL_FAILED",
  UserProfileNotFound = "USER_PROFILE_NOT_FOUND",
  TeamAccessVerificationFailed = "TEAM_ACCESS_VERIFICATION_FAILED",
  Auth0UserRetrievalFailed = "AUTH0_USER_RETRIEVAL_FAILED",
  AccountStatusVerificationFailed = "ACCOUNT_STATUS_VERIFICATION_FAILED",
  MultiOrgUserNotSupported = "MULTI_ORG_USER_NOT_SUPPORTED",
  ResponseProcessingFailed = "RESPONSE_PROCESSING_FAILED",
  BothEmailAndPhoneFailed = "BOTH_EMAIL_AND_PHONE_FAILED",
}
